import React from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

const AuditLogFilterForm = ({ filter, setFilter, onApply }) => {
  const handleChange = (field) => (event) => {
    setFilter((prev) => ({ ...prev, [field]: event.target.value }));
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
      <TextField
        label="User ID"
        type="number"
        value={filter.userId || ""}
        onChange={handleChange("userId")}
      />
      <FormControl sx={{ minWidth: 150 }}>
        <InputLabel>Status</InputLabel>
        <Select
          variant={"outlined"}
          value={filter.status ?? ""}
          label="Status"
          onChange={handleChange("status")}
        >
          <MenuItem value="">Усі</MenuItem>
          <MenuItem value="SUCCESS">SUCCESS</MenuItem>
          <MenuItem value="FAIL">FAIL</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Від (UTC)"
        type="datetime-local"
        InputLabelProps={{ shrink: true }}
        value={filter.from || ""}
        onChange={handleChange("from")}
      />
      <TextField
        label="До (UTC)"
        type="datetime-local"
        InputLabelProps={{ shrink: true }}
        value={filter.to || ""}
        onChange={handleChange("to")}
      />
      <Button variant="contained" onClick={onApply}>Застосувати</Button>
    </Box>
  );
};

export default AuditLogFilterForm;
